<template>
  <v-row>
    <v-col>
      <v-row>
        <v-col cols="12">
          <base-card>
            <v-card-title>
              <div class="d-flex justify-space-between" style="width: 100%;">
                <div class="d-flex justify-space-between px-3">
                  <img src="/mstile-70x70.png" height="36" alt="logo" />
                  <h5 class="ma-0 ml-4 mt-2">Accounting · Financial Overview</h5>
                </div>
                <div class="d-flex flex"></div>
                <div class="d-flex">
                  <div class="date-field">
                    <v-menu
                      v-model="dateMenus.from"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="filters.startDate"
                          label="From"
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ma-0"
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="filters.startDate"
                        :max="filters.endDate || datepickerMax"
                        scrollable
                        @input="() => { dateMenus.from = false; ensureValidRange(); }"
                      />
                    </v-menu>
                  </div>
                  <div class="date-field">
                    <v-menu
                      v-model="dateMenus.to"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="filters.endDate"
                          label="To"
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ma-0"
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="filters.endDate"
                        :min="filters.startDate"
                        :max="datepickerMax"
                        scrollable
                        @input="() => { dateMenus.to = false; ensureValidRange(); }"
                      />
                    </v-menu>
                  </div>
                  <v-btn
                    class="ml-4 mt-4 mt-md-0"
                    dark
                    color="primary"
                    :loading="loading"
                    @click="loadReport"
                  >
                    <v-icon left>mdi-reload</v-icon>
                    Reload
                  </v-btn>
                </div>
              </div>
            </v-card-title>
            <v-progress-linear
              :active="loading"
              :indeterminate="loading"
              absolute
              bottom
              color="deep-purple accent-4"
            />
          </base-card>
        </v-col>
      </v-row>

      <!--<v-row class="mt-4">
        <v-col cols="12">
          <base-card>
            <v-card-text>
              <div class="financial-summary">
                <div class="financial-summary__header">
                  <h3 class="mb-1">Financial Overview</h3>
                  <div class="caption grey--text" v-if="filters.startDate && filters.endDate">
                    {{ filters.startDate }} → {{ filters.endDate }}
                  </div>
                </div>
                <v-divider class="my-4" />
                <v-row>
                  <v-col cols="12" md="4" class="pt-0">
                    <card-dashboard
                      title="Total Revenue"
                      :primaryvalue="formatNumber(summary.totalRevenue)"
                      unit="€"
                    />
                  </v-col>
                  <v-col cols="12" md="4" class="pt-0">
                    <card-dashboard
                      title="Generated Revenue"
                      :primaryvalue="formatNumber(summary.generatedRevenue)"
                      unit="€"
                    />
                  </v-col>
                  <v-col cols="12" md="4" class="pt-0">
                    <card-dashboard
                      title="Inventory Yield"
                      :primaryvalue="formatPercentage(summary.inventoryYield)"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </base-card>
        </v-col>
      </v-row>-->

      <v-row> 
                <v-col cols="12">
                    <div class="metrics-grid">
                        <div class="metrics-griditem" style="grid-column: 1 / span 4; grid-row: 1;">
                            <card-dashboard
                              title="Total Revenue"
                              :primaryvalue="summary.totalRevenue"
                              unit="€"
                              valueformatting="currency"
                            />
                        </div>  
                        <div class="metrics-griditem" style="grid-column: 5 / span 4; grid-row: 1;">
                            <card-dashboard
                              title="Generated Revenue"
                              :primaryvalue="summary.generatedRevenue"
                              unit="€"
                              valueformatting="currency"
                            />
                        </div>  
                        <div class="metrics-griditem" style="grid-column: 9 / span 4; grid-row: 1;">
                            <card-dashboard
                              title="Inventory Yield"
                              :primaryvalue="summary.inventoryYield"
                              valueformatting="percent"
                            />
                        </div>  
                    </div>                    
                </v-col>
            </v-row>

      <v-row class="mt-4">
        <v-col cols="12">
          <base-card>
            <v-card-title class="section-title">Brands & Brand Representatives</v-card-title>
            <v-divider />
            <v-card-text>
              <v-simple-table v-if="hasBrandRows">
                <thead>
                  <tr>
                    <th>Brand</th>
                    <th>Brand Representative</th>
                    <th class="text-right">Generated Revenue</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in brands" :key="row.brand + row.brandLead">
                    <td>{{ row.brand }}</td>
                    <td>{{ row.brandLead || '-' }}</td>
                    <td class="text-right">{{ formatCurrency(row.generatedRevenue) }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
              <div v-else class="empty-state">No revenue data found for the selected range.</div>
            </v-card-text>
          </base-card>
        </v-col>
      </v-row>

      <v-row class="mt-4 mb-8">
        <v-col cols="12">
          <base-card>
            <v-card-title class="section-title">Clusters</v-card-title>
            <v-divider />
            <v-card-text>
              <v-simple-table v-if="hasClusterRows">
                <thead>
                  <tr>
                    <th>Cluster</th>
                    <th>Placement Type</th>
                    <th>Unit</th>
                    <th class="text-right">Unit Price</th>
                    <th class="text-right">Avg. Unit Price</th>
                    <th class="text-right">Generated Revenue</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in clusters" :key="row.cluster + row.unit">
                    <td>{{ row.cluster }}</td>
                    <td>{{ row.placementTypeLabel || row.placementType || '-' }}</td>
                    <td>{{ row.unitLabel || row.unit || '-' }}</td>
                    <td class="text-right">{{ formatCurrency(row.unitPrice, 2) }}</td>
                    <td class="text-right">{{ formatCurrency(row.avgUnitPrice, 2) }}</td>
                    <td class="text-right">{{ formatCurrency(row.generatedRevenue) }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
              <div v-else class="empty-state">No cluster insights available for the selected range.</div>
            </v-card-text>
          </base-card>
        </v-col>
      </v-row>

      <v-snackbar v-model="snackbar.show" :timeout="4000" color="red" bottom>
        {{ snackbar.message }}
      </v-snackbar>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import { srvApi, PATH } from "src/api/index";
import CardDashboard from "@/components/campaigns/CardDashboard";
import { formatCurrencyEUR, formatInteger, formatPercent } from "@/core/number-utils";

export default {
  name: "AccountingFinancialOverview",
  components: {
    CardDashboard,
  },
  data() {
    const today = moment().format("YYYY-MM-DD");
    return {
      loading: false,
      filters: {
        startDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
        endDate: today,
      },
      datepickerMax: today,
      dateMenus: {
        from: false,
        to: false,
      },
      summary: {
        totalRevenue: 0,
        generatedRevenue: 0,
        inventoryYield: 0,
      },
      brands: [],
      clusters: [],
      snackbar: {
        show: false,
        message: "",
      },
    };
  },
  computed: {
    hasBrandRows() {
      return this.brands && this.brands.length > 0;
    },
    hasClusterRows() {
      return this.clusters && this.clusters.length > 0;
    },
  },
  created() {
    this.loadReport();
  },
  methods: {
    ensureValidRange() {
      if (this.filters.startDate && this.filters.endDate && this.filters.startDate > this.filters.endDate) {
        this.filters.endDate = this.filters.startDate;
      }
    },
    async loadReport() {
      this.loading = true;
      try {
        const payload = {
          startDate: this.filters.startDate,
          endDate: this.filters.endDate,
        };
        const { data } = await srvApi.post(PATH.REPORTING_ACCOUNTING_FINANCIAL_OVERVIEW, payload);
        this.summary = {
          totalRevenue: data?.summary?.totalRevenue || 0,
          generatedRevenue: data?.summary?.generatedRevenue || 0,
          inventoryYield: data?.summary?.inventoryYield || 0,
        };
        this.brands = data?.brands || [];
        this.clusters = data?.clusters || [];
        if (data?.filters) {
          this.filters.startDate = data.filters.startDate;
          this.filters.endDate = data.filters.endDate;
        }
      } catch (error) {
        this.snackbar = {
          show: true,
          message: "Unable to load financial overview. Please try again.",
        };
      } finally {
        this.loading = false;
      }
    },
    formatCurrency(value, decimals = 2) {
      return formatCurrencyEUR(value, decimals);
    },
    formatPercentage(value) {
      return formatPercent(value);
    },
    formatNumber(value) {
      return formatInteger(value);
    },
  },
};
</script>

<style scoped lang="scss">
.filters-wrap {
  gap: 16px;
}

.date-field {
  min-width: 180px;
}

.financial-summary__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.financial-summary__metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 24px;
}

.summary-metric {
  display: flex;
  flex-direction: column;
}

.summary-label {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
}

.summary-value {
  font-size: 1.8rem;
  font-weight: 600;
}

.summary-value.danger {
  color: #ff5252;
}

.summary-value.success {
  color: #4caf50;
}

.section-title {
  font-weight: 600;
}

.empty-state {
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
}



.apexcharts-toolbar {
    //background-color: red;
    margin-top: -10px;
}
</style>

<style lang="scss" scoped>
.metrics-grid {
    //background-color: red;
    //margin-top: -10px;
    display: grid;
    grid-template-columns: repeat(8, 1fs [col-start]);
    grid-template-rows: [row1-top] 1fs [row2-bottom] 1fs;
    column-gap: 24px;
    row-gap: 12px;
}

.metrics-griditem {
    //background-color: red;
    //margin-top: -10px;
    
    //border: 2px red solid;
}

.v-card .v-list-item {
    // color: #304156 !important;
}
</style>
